export const blockIconsTravelOtherHousesNew = (
	<span className='material-symbols-outlined'>other_houses</span>
);
